import {IDataModel} from "../../services/IDataModel";
import {Http, URLSearchParams, RequestOptions} from "@angular/http";
import {IDataFilter} from "../../services/DataTable";
import * as _ from "lodash";
import {Observable} from "rxjs/Rx";
import {ResponseModel, ListResponseModel} from "../response/response.model";
import {Injectable} from "@angular/core";
import {ClientAccountsModel} from './client-accounts.model';

@Injectable()
export class ClientAccountsService {

    private API_ROOT:string = '/client/accounts';

    constructor(private http:Http) {
    }

    getListByClient(clientId:number, filter?:IDataFilter): Observable<ListResponseModel<ClientAccountsModel>>  {
        let params:URLSearchParams = new URLSearchParams();
        for (let key in filter) {
            params.set(key, filter[key]);
        }

        return this.http
            .get(`/clients/${clientId}/accounts`, new RequestOptions({
                search: params
            }))
            .map((res) => res.json());
    }

}


// WEBPACK FOOTER //
// ./src/app/models/client-accounts/client-accounts.service.ts